(function () {
  'use strict';

  if (window.ATOZ_CART_DRAWER_ENABLED !== true) {
    return;
  }

  var blockedEvents = [
    'rebuy:smartcart.show',
    'rebuy:smartcart.open',
    'rebuy:smartcart.toggle',
    'rebuy:open-cart',
    'rebuy:cart.show',
    'rebuy:cart.open',
    'rebuy:cart.toggle',
    'rebuy:drawer.open'
  ];

  var pollCount = 0;
  var maxPollCount = 50;
  var pollDelay = 100;

  function blockEvent(event) {
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }

    if (event && typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    if (event && typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }

    return false;
  }

  function safeNoop() {
    return false;
  }

  function wrapMethod(owner, methodName) {
    var original;

    if (!owner || typeof owner[methodName] !== 'function') {
      return false;
    }

    if (owner[methodName].__atozRebuyOpenSuppressed) {
      return true;
    }

    original = owner[methodName];

    try {
      owner[methodName] = function () {
        return safeNoop();
      };
      owner[methodName].__atozRebuyOpenSuppressed = true;
      owner[methodName].__atozOriginalMethod = original;
      return true;
    } catch (error) {
      return false;
    }
  }

  function wrapRebuyOpenMethods() {
    var rebuy = window.Rebuy;

    if (!rebuy) {
      return false;
    }

    return [
      wrapMethod(rebuy.SmartCart, 'open'),
      wrapMethod(rebuy.SmartCart, 'show'),
      wrapMethod(rebuy.SmartCart, 'toggle'),
      wrapMethod(rebuy.Cart, 'open')
    ].some(Boolean);
  }

  blockedEvents.forEach(function (eventName) {
    document.addEventListener(eventName, blockEvent, true);
    window.addEventListener(eventName, blockEvent, true);
  });

  function pollForRebuy() {
    wrapRebuyOpenMethods();
    pollCount += 1;

    if (pollCount < maxPollCount) {
      window.setTimeout(pollForRebuy, pollDelay);
    }
  }

  pollForRebuy();
})();
